import { render, staticRenderFns } from "./deal.vue?vue&type=template&id=900cdc20"
import script from "./deal.vue?vue&type=script&lang=js"
export * from "./deal.vue?vue&type=script&lang=js"
import style0 from "./deal.vue?vue&type=style&index=0&id=900cdc20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports